module.exports = __webpack_public_path__ + "img/avatar-wilson-chen.e3282930.webp";